<template>
  <div id="app" class="container">
    <main-header v-if="showMainHeader" />
    <router-view class="main-content" />
    <notification-manager />
    <welcome-message v-if="renderWelcome" />
    <app-feature-toggle></app-feature-toggle>
    <connection-loading></connection-loading>
    <portal-target name="portal-render"></portal-target>
    <user-notifications />
    <publish-modal />
  </div>
</template>

<script>
import '@hotmart-org-ca/cosmos/dist/alert/variations/danger.css'
import '@hotmart-org-ca/cosmos/dist/alert/variations/info.css'
import '@hotmart-org-ca/cosmos/dist/alert/variations/success.css'
import '@hotmart-org-ca/cosmos/dist/alert/variations/warning.css'
import '@hotmart-org-ca/cosmos/dist/breadcrumb/breadcrumb.css'
import '@hotmart-org-ca/cosmos/dist/button-group/button-group.css'
import '@hotmart-org-ca/cosmos/dist/button/button.css'
import '@hotmart-org-ca/cosmos/dist/button/variations/danger.css'
import '@hotmart-org-ca/cosmos/dist/button/variations/primary.css'
import '@hotmart-org-ca/cosmos/dist/button/variations/secondary.css'
import '@hotmart-org-ca/cosmos/dist/button/variations/small.css'
import '@hotmart-org-ca/cosmos/dist/button/variations/tertiary.css'
import '@hotmart-org-ca/cosmos/dist/button/variations/warning.css'
import '@hotmart-org-ca/cosmos/dist/dropdown/dropdown-toggle.css'
import '@hotmart-org-ca/cosmos/dist/form/form.css'
import '@hotmart-org-ca/cosmos/dist/form/input-checkbox.css'
import '@hotmart-org-ca/cosmos/dist/form/input-custom.css'
import '@hotmart-org-ca/cosmos/dist/form/input-default.css'
import '@hotmart-org-ca/cosmos/dist/form/input-radio.css'
import '@hotmart-org-ca/cosmos/dist/form/input-switch.css'
import '@hotmart-org-ca/cosmos/dist/form/input-validate.css'
import '@hotmart-org-ca/cosmos/dist/input-group/input-group.css'
import '@hotmart-org-ca/cosmos/dist/styles/base.css'
import '@hotmart-org-ca/cosmos/dist/styles/reset.css'
import '@hotmart-org-ca/cosmos/dist/styles/theme.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/grays.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/yellow.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/green.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/background/variations/red.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/border/border.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/border/variations/blue.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/border/variations/brand-primary.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/border/variations/grays.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/border/variations/red.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/border/variations/green.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/display/display.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/flex/flex.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/overflow/overflow.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/position/position.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/sizing/sizing.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/spacing/spacing.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/text.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/blue.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/brand-primary.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/grays.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/green.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/red.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/text/variations/yellow.css'
import '@hotmart-org-ca/cosmos/dist/styles/utilities/cursor.css'
import '@hotmart-org-ca/cosmos/dist/tag/variations/small.css'

import '@hotmart-org-ca/cosmos/dist/alert'
import '@hotmart-org-ca/cosmos/dist/avatar'
import '@hotmart-org-ca/cosmos/dist/collapse'
import '@hotmart-org-ca/cosmos/dist/dropdown'
import '@hotmart-org-ca/cosmos/dist/header'
import '@hotmart-org-ca/cosmos/dist/loading'
import '@hotmart-org-ca/cosmos/dist/menu-item'
import '@hotmart-org-ca/cosmos/dist/modal'
import '@hotmart-org-ca/cosmos/dist/modal/modal-body'
import '@hotmart-org-ca/cosmos/dist/modal/modal-footer'
import '@hotmart-org-ca/cosmos/dist/modal/modal-header'
import '@hotmart-org-ca/cosmos/dist/select'
import '@hotmart-org-ca/cosmos/dist/select-multiple'
import '@hotmart-org-ca/cosmos/dist/toast'
import '@hotmart-org-ca/cosmos/dist/tooltip'
import '@hotmart-org-ca/cosmos/dist/tag'

import { mapActions, mapState } from 'vuex'
import MainHeader from 'core/components/MainHeader/MainHeader'
import WelcomeMessage from 'core/components/WelcomeMessage/WelcomeMessage'
import AppFeatureToggle from 'core/components/AppFeatureToggle/AppFeatureToggle'
import ConnectionLoading from 'core/components/ConnectionLoading/ConnectionLoading'
import UserNotifications from './core/components/MainHeader/UserNotifications/UserNotifications'
import PublishModal from './core/components/PublishModal/PublishModal'
import ProductFruits from './productFruits'
export default {
  name: 'app',
  components: {
    MainHeader,
    WelcomeMessage,
    AppFeatureToggle,
    ConnectionLoading,
    UserNotifications,
    PublishModal
  },
  data: () => ({
    translated: false
  }),
  computed: {
    ...mapState('auth', [
      'isLogged', 'user'
    ]),
    ...mapState('builder', [
      'templateHasUnsavedChanges'
    ]),
    showMainHeader () {
      return this.isLogged && this.$route.name !== 'login'
    },
    renderWelcome () {
      return !this.$route.path.includes('login')
    }
  },
  methods: {
    ...mapActions('datahubEvents', {
      sendDropoffBuilderConfig: 'SEND_DROPOFF_BUILDER_CONFIG'
    }),
    sendDropoffConfig () {
      if (this.templateHasUnsavedChanges) {
        this.sendDropoffBuilderConfig({ type: 'close', lastComponentEdited: this.currentComponentName })
      }
    }
  },
  created () {
    window.addEventListener('beforeunload', this.sendDropoffConfig)
  },
  mounted () {
    ProductFruits.start(this.user)
  }
}
</script>

<style lang="scss">
  @import '~stylesheets/utils.scss';
</style>

<style lang="scss" scoped>
  @import '~stylesheets/meta';
  @import '~stylesheets/app';

  .container {
    --sidebar-width: 480px;
    --sidebar-backdrop-bg: none;
    --sidebar-backdrop-pointer-events: none;
    height: 100vh;
  }

  .main-content {
    padding-top: var(--structure-header-height, 70px);
    height: 100vh;
  }
</style>
